// extracted by mini-css-extract-plugin
module.exports = {"block":"NotFound_block__1qcYJ","text":"NotFound_text__3yRo_"};